export default{

    'title': '** Amej **',
    'token': window.localStorage.getItem("token"),
    'groups': [],
    'profile':[],
    'recentProfile':[],
    'kycdata':[],
    'kycrequestmessage':'',
    'registerErrors':{},
    'registerEmail':'',
    'otpExpiresIn':10,
    'registerStatus':null,
    'accountsuccessmessage':'',
    'downloadsuccess':'',
    'requestid':'',
    'useramount':'',
    'transactions':[],
    'payment':[],
    'help':[],
    'loadfund':[],
    'banks':[], 
    'notifications':[],
    'staticpage':[],
    'requests':[],
    'message':[],
    'funds':[],
    'phonenumber':[],
    'step':1,
    'passwordmessage':[],
    'successmessage':'',
    'otpsuccess':'',
    'otperror':'',
    'requestmessage':'',
    'otpmessage':'',
    'errormessage':'',
    'actionurl':'',
    'address':'',
    'addbanksuccess':'',
    'withdraw_id':'',
    'setotpSuccessMessage':'',
    'merchant':'',
    'cardloaderrormessage':'',
    'allbanks': [], 
    "fundResponse":[],
    "countries":[],
    "sQuestions": [], // Security Question List
    "sQuestionAnswers": [], // Security Question Answers by Usere
    "documentTypes": [], // all document type list
    "userDocuments": [], // all document list uploaded by user
    "timezones": [], // all timezone list
    "currencies": [], // all currencies list
    "currencyCountries": [], // country -> display currency map
    "adminBanks": [], // all admin banks
    "userBanks": [], // all users selected banks
    "payuHash": [], // get payu hash code with other required data
    "merchants": [], // Merchant collected documents data 
    "merchant_documents": [], // Merchant collected documents data 
    "merchant_payment_details": [], // Merchant payment details by Transaction id 
    "merchant_withdraw": [],
    "merchant_key": [],
    "merchant_dashboard_count": [],
    "merchant_dashboard_transaction": [],
    "merchant_dashboard_cashflow": [],
    "merchantPayments": { count: 0, limit: 20, offset: 0, results: [] },
    "merchantPaymentDetail": {},
    "userPayments": [],
    "paymentRequests": [],
    "userKyc": {},
    "mpinStatus": {},
    "paymentIntent": {},
    "userBankDetail": {},
    "userWithdraws": [],
    "recipient": {},
    "merchantWithdraws": { count: 0, limit: 20, offset: 0, filters: {}, withdraw_limits: {},
                           withdraw_fees: {}, settlement_banks: [], funds: {}, results: [] },
    "merchantWithdrawAnalytics": {},
    "merchantDashboard": {},
    "userStatement": { wallet: {}, range: {}, filters: {}, summary: {}, pagination: { count: 0, limit: 20, offset: 0 }, results: [] },
    "userStatementDetail": {},
    "merchantStatement": { wallet: {}, range: {}, filters: {}, summary: {}, pagination: { count: 0, limit: 20, offset: 0 }, results: [] },
    "merchantAnalytics": {},
    "merchantCustomers": {},
    // Global Live / Sandbox switch (persisted so it survives a refresh)
    "merchantEnvironment": window.localStorage.getItem("merchantEnvironment") || "live",
}
